import {library} from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDown,
  faAngleLeft,
  faAngleUp,
  faBars,
  faFilter,
  faSort,
  faStar
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import Vue from 'vue';
import Vuex from 'vuex';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/tailwind.css';
import './assets/css/main.css';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

library.add([faAngleLeft, faAngleUp, faAngleDown, faFilter, faBars, faSort, faStar])

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false;

Vue.use(Vuex);
Vue.use(router);
Vue.config.devtools = true

new Vue({
    el: '#app',
    router,
    components: {App},
    template: '<App/>',

    created() {
        Vue.prototype.$dashboardStore = store;
        // check if user is set in locale storage, if so set in store
        const userObj = JSON.parse(
         window.localStorage.getItem(process.env.VUE_APP_LOCALSTORAGETAG)
        );
        if (userObj !== null) {
            this.$dashboardStore.dispatch('setUserObject', userObj);
        }
    },
    render: (h) => h(App),
});
